import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl, CheckboxControl} from 'appShared/classes/controls';
import {FeedTypesEnum, HttpStatusCodesEnum, ServerResponse, ServerResponseData, SesService} from '@spa/api';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {switchMap} from 'rxjs/operators';
import {Helper} from 'appShared/classes';
import {MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {forkJoin} from 'rxjs';
import {BaseMarketDataForm} from 'appShared/forms';
import {MarketDataFeedAndBundleDeleteInterface} from 'appEntries/panel/interfaces';
import {FEEDID_CHECKBOX_PREFIX} from 'appAssets/descriptors';

export class RemoveFeedForm extends BaseMarketDataForm {
    private readonly feeds: MarketDataFeedAndBundleDeleteInterface[];
    public feedBundleFromGroup: FormGroup;
    public feedBundleControls: BaseControl[];

    constructor(sesService: SesService, feeds: MarketDataFeedAndBundleDeleteInterface[]) {
        super(sesService);
        this.feeds = feeds;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        const feedControls = [];

        this.feedBundleFromGroup = new FormGroup({});
        const feedBundleControls = [];

        for (const feed of this.feeds) {

            if (feed.feedType === FeedTypesEnum.MarketDataFeed) {
                feedControls.push(
                    new CheckboxControl({
                        name: `${FEEDID_CHECKBOX_PREFIX}${feed.id}`,
                        value: feed.id,
                        placeholder: feed.name,
                        validators: [],
                        componentType: ComponentTypesEnum.Checkbox,
                        floatingLabelNever: true,
                        checked: false,
                        color: ColorCodesEnum.Primary,
                        expectBooleanValue: false
                    })
                );
            } else {
                feedBundleControls.push(
                    new CheckboxControl({
                        name: `${FEEDID_CHECKBOX_PREFIX}${feed.id}`,
                        value: feed.id,
                        placeholder: feed.name,
                        validators: [],
                        componentType: ComponentTypesEnum.Checkbox,
                        floatingLabelNever: true,
                        checked: false,
                        color: ColorCodesEnum.Primary,
                        expectBooleanValue: false
                    })
                );
            }
        }

        this.controls = feedControls.map((control: BaseControl) => {
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
        this.feedBundleControls = feedBundleControls.map((control: BaseControl) => {
            this.feedBundleFromGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    createRequest(): ServerResponse<boolean> {
        const ids: number[] = [];
        const bundleIds: number[] = [];

        // tslint:disable-next-line:forin
        for (const property in this.formGroup.value) {
            const feedId = this.formGroup.value[property];
            if (feedId > 0) {
                ids.push(feedId);
            }
        }

        // tslint:disable-next-line:forin
        for (const property in this.feedBundleFromGroup.value) {
            const feedId = this.feedBundleFromGroup.value[property];
            if (feedId > 0) {
                bundleIds.push(feedId);
            }
        }

        if (ids.length === 0 && bundleIds.length === 0) {
            return Helper.createSuccessResponseObservable<boolean>(true);
        }

        const joins = [];

        if (ids.length > 0) {
            joins.push(this.sesService.deleteMarketDataFeedByIdList(ids));
        }

        if (bundleIds.length > 0) {
            joins.push(this.sesService.deleteMarketDataFeedBundleByIdList(bundleIds));
        }

        return forkJoin(joins).pipe(
            switchMap((registerResponse: ServerResponseData<any>[]) => {
                const errorResponse = registerResponse.find(response => response && response.status !== HttpStatusCodesEnum.Ok);

                if (errorResponse) {
                    return Helper.errorsHelper().createErrorResponseObservable<any>(
                        errorResponse,
                        MarketDataFeedsFormErrorStatesEnum.DeleteMarketDataFeedFailed
                    );
                }

                return Helper.createSuccessResponseObservable<boolean>(true);
            }));
    }
}
